import { newPlantarApi } from '@/config/appAPIs'

const api = {
  resource: '',
  module: '',
  profile: '',
  version: 1,
  request: newPlantarApi,

  setModule(module: string) {
    this.module = module
    return this
  },

  setProfile(profile: string) {
    this.profile = profile
    return this
  },

  setApiVersion(version?: number) {
    this.version = version || 1
    return this
  },

  setResource(resource: string) {
    this.resource = resource
    return this
  },

  getPath(resourceId?: string) {
    const version = this.version || 1
    const parts = [this.module, `v${version}`, this.profile, this.resource]

    if (resourceId) parts.push(resourceId)

    return parts.filter(Boolean).join('/')
  },

  async get<T>(resourceId?: string, params?: any, options?: any) {
    return newPlantarApi.get<T>(this.getPath(resourceId), {
      ...options,
      params,
      paramsSerializer: { indexes: null }
    })
  },

  async post<T>(resourceId?: string, data?: any, options?: any, isMultipart?: boolean) {
    const headers = isMultipart ? { 'Content-Type': 'multipart/form-data' } : {}

    return newPlantarApi.post<T>(this.getPath(resourceId), data, {
      headers,
      ...options
    })
  },

  async put<T>(resourceId?: string, data?: any, options?: any, isMultipart?: boolean) {
    const headers = isMultipart ? { 'Content-Type': 'multipart/form-data' } : {}

    return newPlantarApi.put<T>(this.getPath(resourceId), data, {
      headers,
      ...options
    })
  },

  async delete(resourceId?: string, data?: any) {
    return newPlantarApi.delete(this.getPath(resourceId), { data })
  }
}

export default api
